export default __webpack_public_path__ + "static/media/games.35bd136c.png";